import React from "react";
import "../css/Pages.css";

const Home = () => {
  return (
    <div className="page home">

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-text">
          <h1>Welcome to Foodies</h1>
          <p>
            Fresh ingredients, bold flavors, and food crafted with care.
            Experience taste that feels like home.
          </p>
          <button className="hero-btn">Explore Menu</button>
        </div>

        <div className="hero-img">
          <img
            src="https://images.pexels.com/photos/2116094/pexels-photo-2116094.jpeg"
            alt="Delicious Food"
          />
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <h2 className="section-title">Why Choose Us</h2>
        <div className="features-grid">
          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1540189549336-e6e99c3679fe"
              alt="Fresh Food"
            />
            <h3>Fresh Ingredients</h3>
            <p>Only the finest and freshest ingredients in every dish.</p>
          </div>

          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1551218808-94e220e084d2"
              alt="Chef"
            />
            <h3>Expert Chefs</h3>
            <p>Prepared by experienced chefs with passion and precision.</p>
          </div>

          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1528605248644-14dd04022da1"
              alt="Delivery"
            />
            <h3>Fast Delivery</h3>
            <p>Hot, fresh, and delivered right to your doorstep.</p>
          </div>
        </div>
      </section>

      {/* Popular Dishes */}
      <section className="popular-dishes">
        <h2 className="section-title">Popular Dishes</h2>
        <div className="dishes-grid">
          <div className="dish-card">
            <img
              src="https://images.pexels.com/photos/604969/pexels-photo-604969.jpeg"
              alt="Pizza"
            />
            <h4>Margherita Pizza</h4>
          </div>
          <div className="dish-card">
            <img
              src="https://images.pexels.com/photos/1639562/pexels-photo-1639562.jpeg"
              alt="Burger"
            />
            <h4>Cheesy Burger</h4>
          </div>
          <div className="dish-card">
            <img
              src="https://images.pexels.com/photos/1279330/pexels-photo-1279330.jpeg"
              alt="Pasta"
            />
            <h4>Creamy Pasta</h4>
          </div>
          <div className="dish-card">
            <img
              src="https://images.unsplash.com/photo-1627308595229-7830a5c91f9f"
              alt="Salad"
            />
            <h4>Fresh Salad</h4>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials">
        <h2 className="section-title">What Our Customers Say</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <p>"Amazing food! Tastes just like home and delivered hot."</p>
            <h5>- Priya R.</h5>
          </div>
          <div className="testimonial-card">
            <p>"The pizza is my favorite. Fresh and delicious every time."</p>
            <h5>- Rahul S.</h5>
          </div>
          <div className="testimonial-card">
            <p>"Friendly service and amazing chefs. Highly recommend!"</p>
            <h5>- Anjali M.</h5>
          </div>
        </div>
      </section>
      <section className="testimonials">
        {/* <h2 className="section-title">What Our Customers Say</h2> */}
        <br />
        <br />
        
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <p> "The sushi platter is amazing! Each roll is fresh, beautifully presented, 
        and the taste is authentic. Perfect place for family dinners or celebrations."</p>
            <h5>- Vinneta R.</h5>
          </div>
          <div className="testimonial-card">
            <p>"Foodies makes ordering so easy. The grilled steak was cooked to perfection, 
        seasoned wonderfully, and the flavors were spot on. Highly recommend!"</p>
            <h5>- Kripa S.</h5>
          </div>
          <div className="testimonial-card">
            <p> "I appreciate the attention to detail. Each dish looks amazing, 
        tastes fresh, and the portion sizes are generous. Definitely my go-to food delivery."</p>
            <h5>- Prince M.</h5>
          </div>
        </div>
      </section>    

    </div>
  );
};

export default Home;
    